/**
 * FolderCardSkeleton · 文件夹卡片骨架
 *
 * 外形 / 尺寸与 FolderCard 对齐：盒模型 padding 走共享 CSS 变量
 * （--folder-card-pad，与 FolderCard、.grid 列宽同源），保证加载态与真实
 * 列表的卡片宽度、间距完全一致；内部 3 块 shimmer 占位（图标 / 名称 / 张数）。
 * 颜色比常规骨架略淡。
 */

import React from 'react'
import styles from './FolderCardSkeleton.module.scss'

const FolderCardSkeleton: React.FC = () => (
  <div className={styles.card} aria-hidden="true">
    <span className={styles.icon} />
    <span className={styles.name} />
    <span className={styles.count} />
  </div>
)

export default FolderCardSkeleton
